var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-full',[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"text-center"},[_c('h1',[_vm._t("default")],2),_vm._v(" "),_c('b-button',{staticClass:"btn btn-secondary btn-round",on:{"click":function($event){return _vm.$router.push({name: 'home'})}}},[_vm._v("GO TO HOME PAGE")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0737f7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/exception-page.vue
// module id = null
// module chunks = 